import axios from '../request/http';

const operate = {
    // banner列表
    bannerList(params) {
        return axios.get("/admin/operation/banner/list", { params });
    },
    // banner更新
    statusChange(params) {
        return axios.get("/admin/operation/banner/update", { params });
    },
    // banner列表
    addBannerList(params) {
        return axios.post("/admin/operation/banner/edit", params);
    },
    // 分享图列表
    shareImgList(params) {
        return axios.get("/admin/operation/share-img/list", params);
    },
    // 分享图更新
    shareImgChange(params) {
        return axios.get("/admin/operation/share-img/update", { params });
    },
    // 分享图修改
    shareImgUpdata(params) {
        return axios.post("/admin/operation/share-img/edit", params);
    },
    // 使用帮助列表
    helpList(params) {
        return axios.get("/admin/operation/help/list", { params });
    },
    // 使用帮助列表显示
    helpListChange(params) {
        return axios.get("/admin/operation/help/update", { params });
    },
    // 使用帮助列表修改
    helpListUpdata(params) {
        return axios.post("/admin/operation/help/edit", params);
    },
    // 反馈列表
    feedbackList(params) {
        return axios.get("/admin/operation/feedback", { params });
    },
    // 反馈处理
    feedbackUpdate(params) {
        return axios.get("/admin/operation/feedback/update", { params });
    },
    // 渠道列表
    channelList(params) {
        return axios.get("/admin/channel/listAll", { params });
    },
    // 渠道新增
    channelAdd(data) {
        return axios.post("/admin/channel/addOrEdit", data);
    },
    // 渠道上下架
    channelStatus(params) {
        return axios.get("/admin/channel/status", { params });
    },
    // 消息模板列表
    msgList(params) {
        return axios.get("/admin/messageTemplate/list", { params });
    },
    // 消息模板新增/修改
    addMsgUpdate(data) {
        return axios.post("/admin/messageTemplate/addOrUpdate", data);
    },

    // 艾信通广播新增
    addCompanyArticle(data) {
        return axios.post("/admin/company-article/edit", data);
    },
    // 艾信通广播列表
    getCompanyArticleList(params) {
        return axios.get("/admin/company-article/list", { params });
    },
    // 艾信通广播状态更新
    companyArticleUpdateStatus(params) {
        return axios.get("/admin/company-article/update-status", { params });
    },
    // 艾信通广播获取详情
    companyArticleDetail(params) {
        return axios.get("/admin/company-article/detail", { params });
    },
    // 艾信通广播发布
    companyArticleSend(params) {
        return axios.get('/admin/company-article/send/msg', { params })
    }

}

export default operate;


// WEBPACK FOOTER //
// ./src/api/operate.js